import { render } from "./EnviarEmailCodigosModal.vue?vue&type=template&id=ddebbffe"
import script from "./EnviarEmailCodigosModal.vue?vue&type=script&lang=js"
export * from "./EnviarEmailCodigosModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__